module.exports = __webpack_public_path__ + "img/pa.d0787677.svg";